import React, { Component } from "react";
import ReactApexChart from "react-apexcharts";
import { PropTypes } from "prop-types";

class LineColumnArea extends Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [
        // {
        //   name: "Team A",
        //   type: "column",
        //   data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
        // },
        // {
        //   name: "Team B",
        //   type: "area",
        //   data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
        // },
        // {
        //   name: "Team C",
        //   type: "line",
        //   data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
        // },
      ],
      options: {
        chart: {
          stacked: false,
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: [0, 2, 4],
          curve: "smooth",
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
          },
        },
        colors: ["#f46a6a", "#556ee6", "#34c38f"],

        fill: {
          opacity: [0.85, 0.25, 1],
          gradient: {
            inverseColors: false,
            shade: "light",
            type: "vertical",
            opacityFrom: 0.85,
            opacityTo: 0.55,
            stops: [0, 100, 100, 100],
          },
        },
        labels: [
          "01/01/2023",
          "02/01/2023",
          "03/01/2023",
          "04/01/2023",
          "05/01/2023",
          "06/01/2023",
          "07/01/2023",
          "08/01/2023",
          "09/01/2023",
          "10/01/2023",
          "11/01/2023",
        ],
        markers: {
          size: 0,
        },
        legend: {
          offsetY: 11,
        },
        xaxis: {
          type: "datetime",
        },
        yaxis: {
          title: {
            text: "",
          },
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: function (y) {
              if (typeof y !== "undefined") {
                return y.toFixed(0) + "$";
              }
              return y;
            },
          },
        },
        grid: {
          borderColor: "#f1f1f1",
        },
      },
    };
  }
  render() {
    return (
      <React.Fragment>
        <ReactApexChart
          options={{
            ...this.state.options,
            labels: this.props.data?.labels || [],
          }}
          series={this.props.data?.items || []}
          type="line"
          height="322"
          className="apex-charts"
        />
      </React.Fragment>
    );
  }
}

LineColumnArea.propTypes = {
  data: PropTypes.any,
};

export default LineColumnArea;
